/* src/app/private/components/roles/role-details/role-details.component.scss */
/*# sourceMappingURL=role-details.component.css.map */
